import React from 'react'

import { classNames } from 'primereact/utils'

import { EInvoiceAttachment } from '../../../../data/models'
import { DocumentPreviewCard } from '../document-preview-card'
import { LoadingDocumentPreviewCard } from '../document-preview-card/LoadingDocumentPreviewCard'

type Props = {
  documents?: EInvoiceAttachment[]
  isLoading?: boolean
  showAsColumn?: boolean
}

export const DocumentList: React.FC<Props> = ({
  documents,
  isLoading = false,
  showAsColumn = false,
}) => {
  if (!documents || documents.length === 0) return null

  if (isLoading) {
    return (
      <div className="flex flex-wrap gap-2">
        {Array.from({ length: 2 }).map((_blank, index) => (
          <LoadingDocumentPreviewCard key={index} />
        ))}
      </div>
    )
  }

  return (
    <div
      className={classNames('flex flex-wrap gap-2', {
        'flex-column': showAsColumn,
      })}
    >
      {documents.map(document => (
        <div key={document.Id} className="">
          <DocumentPreviewCard attachment={document} fullWidth={showAsColumn} />
        </div>
      ))}
    </div>
  )
}
